ACC.minicart = {
  $layer: $('#miniCartLayer'),

  bindMiniCart: function() {
    $(document).on('mouseenter', '.miniCart', this.showMiniCart);
    $(document).on('mouseleave', '.miniCart', this.hideMiniCart);
  },

  showMiniCart: function() {
    if (ACC.minicart.$layer.data('hover')) {
      return;
    }


    if (ACC.minicart.$layer.data('needRefresh') !== false) {
      ACC.minicart.getMiniCartData(function() {
        ACC.minicart.$layer.fadeIn(function() {
          ACC.minicart.$layer.data('hover', true);
          ACC.minicart.$layer.data('needRefresh', false);
        });
      });
    }

    ACC.minicart.$layer.fadeIn(function() {
      ACC.minicart.$layer.data('hover', true);
    });
  },

  hideMiniCart: function() {
    ACC.minicart.$layer.fadeOut(function() {
      ACC.minicart.$layer.data('hover', false);
    });
  },

  getMiniCartData: function(callback) {
    $.ajax({
      url: ACC.minicart.$layer.attr('data-rolloverPopupUrl'),
      cache: false,
      type: 'POST',
      success: function(result) {
        ACC.minicart.$layer.html(result);
        callback();
      }
    });
  },

  refreshMiniCartCount: function() {
    $.ajax({
      dataType: 'json',
      /* eslint-disable no-mixed-operators*/
      url: ACC.minicart.$layer.attr('data-refreshMiniCartUrl') + Math.floor(Math.random() * 101) * new Date().getTime(),
      /* eslint-enable no-mixed-operators*/
      success: function(data) {
        $('.miniCart .count').html(data.miniCartCount);
        $('.miniCart .price').html(data.miniCartPrice);
        ACC.minicart.$layer.data('needRefresh', true);
      }
    });
  }
};

$(document).ready(function() {
  var minicartrollPopup = '.ph-minirollover_popup';

  ACC.minicart.bindMiniCart();

  $(document).on('click', '.ph-shoppingcarticon', function() {
    if ($('.page-quoteCheckoutSummaryPage').length === 0 && $('.ph-quoteIdFromSession').length === 0) {
      $.ajax({
        url: ACC.config.encodedContextPath + '/cart/rollover/MiniCart',
        cache: false,
        type: 'GET',
        success: function(cartResult) {
          ACC.minicart.$layer.html(cartResult);

          if ($(minicartrollPopup).height() > window.innerHeight &&
           (window.orientation === 90 || window.orientation === -90)) {
            $(minicartrollPopup).attr('style', 'height:87vh !important');
          }
        }
      });
      $('.mini-cart').toggleClass('hidden');
    }
  });

  $(document).on('click', '.ph-continue_shopping', function() {
    $('.mini-cart').addClass('hidden');
  });

  $(document).on('click', '.ph-closeminicart', function() {
    $(minicartrollPopup).addClass('hidden');
  });

  $('body').on('click', function(event) {
    if (!$(minicartrollPopup).is(event.target) && $(minicartrollPopup).has(event.target).length === 0 &&
    !$('.ph-shoppingcarticon').is(event.target)) {
      $(minicartrollPopup).addClass('hidden');
    }
  });
});
